import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Feeds the native tab bar's notifications badge (bridge tab-badge) — the iOS tab bar item,
// the Android bottom bar's pill.
//
// Lives on the body of every signed-in native page (see body_bridge_attributes), like
// bridge--tab-avatar: the count refreshes on each navigation — same cadence as the web
// bottom bar badge, which is server-rendered per page.
export default class extends BridgeComponent {
  static component = 'tab-badge'
  static values = { count: Number }

  #refresh = (event) => {
    this.send('connect', { count: event.detail.count })
  }

  connect() {
    super.connect()
    // Un aperçu du cache Turbo porte le compteur de l'époque de sa mise en cache (les
    // sous-onglets du profil sont préchargés dès l'affichage) : seule la page fraîche compte.
    if (!document.documentElement.hasAttribute('data-turbo-preview')) {
      this.send('connect', { count: this.countValue })
    }
    // Mise à jour sans navigation (ex. notifications marquées vues à la sélection de
    // l'onglet — cf. notifications-seen controller).
    window.addEventListener('tab-badge:refresh', this.#refresh)
  }

  disconnect() {
    window.removeEventListener('tab-badge:refresh', this.#refresh)
    super.disconnect()
  }
}
